// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__32SK0","cell":"ColumnAccessor_cell__1SDb2","firstCellAccent":"ColumnAccessor_firstCellAccent__1i8i0"};